import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { service_methods6 } from '../admin/service_methods6';

@Component({
  selector: 'app-dashboardsubmenu',
  templateUrl: './dashboardsubmenu.component.html',
  styleUrls: ['./dashboardsubmenu.component.css']
})
export class DashboardsubmenuComponent implements OnInit {

  constructor(private router: Router,private obj:service_methods6,private activeroute: ActivatedRoute ) {
    activeroute.params.subscribe(val =>{
      this.routerlink = this.router.url;
      this.bindbreadcrumb();
      this.bindsubmenus();
    })
   }
  arr_breadcumm=[]
  arr_submenus=[]
  routerlink:string
  ngOnInit(): void {
  }
  async bindsubmenus()
  {
     await this.obj._commonget("menu_getmenussub?route=" + this.routerlink + "").then((data)=>{
    this.arr_submenus=data;
    })
  }

  async bindbreadcrumb()
  {
     await this.obj._commonget("menu_getmenusbreadcrumb_sub?route=" + this.routerlink + "").then((data)=>{
    this.arr_breadcumm=data;
   
    })
  }
}
